import { useRequest } from 'domain/core/hooks/useRequest';

// TODO MADE ERRORS NOTIFICATION
export const useGetProfileAvatars = () => {
  const { data, isLoading } = useRequest({
    url: '/api/v1/media/getAvatarsList',
    sendOnStart: true,
  });

  return { data, isLoading };
};
